import _get from 'lodash.get';
import { credentials } from '@shootsta/client-auth';
import _isObjectLike from 'lodash.isobjectlike';
import { VIDEO_OUTPUT_STATUS, ASSET_QUALITY, PRODUCT_TYPE } from '@shootsta/common-domain-data';
import {
  CAPTION_TYPES,
  LABELS_MAP,
  EXCLUDED_ORIGINAL_QUALITY_PRODUCTS } from
'../constants';

const getCurrentUserId = () => {
  const { user: { userId } = {} } = { user: {}, ...credentials.get() };

  return userId;
};

export const isCaption = (type) => CAPTION_TYPES.includes(type);

export const isAssetExists = (asset) => (key) =>
asset.assetFiles[key] && _isObjectLike(asset.assetFiles[key]);


export const isAssetFileValid = (assetFile) => {
  const { type, metaData } = assetFile;

  if (!LABELS_MAP[type]) {
    return false;
  }

  if (!isCaption(type)) {
    return true;
  }

  return _get(metaData, 'lang');
};

export const appendMetadataToOption = (assetFile) => {
  if (!assetFile.metaData) {
    return assetFile;
  }

  try {
    const metaData = JSON.parse(assetFile.metaData);

    return { ...assetFile, metaData };
  } catch (e) {
    return assetFile;
  }
};

export const isAllowedDownloadOption = (
videoStatus,
videoProduct) =>
(key) => {
  if (key === ASSET_QUALITY.ORIGINAL) {
    return videoProduct === PRODUCT_TYPE.PRO && videoStatus === VIDEO_OUTPUT_STATUS.APPROVED;
  }

  return true;
};

export const transformKeysToOptionsArray = (asset) => (
files, fileType) =>
{
  const appendCaption = isCaption(fileType) && Array.isArray(asset.assetFiles[fileType]);

  return appendCaption ?
  [...files, ...asset.assetFiles[fileType]] :
  [...files, asset.assetFiles[fileType]];
};

export const canDownloadOriginalQuality = (asset) => (key) => {
  if (key === ASSET_QUALITY.ORIGINAL) {
    const userId = getCurrentUserId();
    const assetCreatorId = _get(asset, 'createdByUser.userId');

    if (!assetCreatorId) {
      return false;
    }

    const isTheSameUser = userId === assetCreatorId;

    return isTheSameUser && !EXCLUDED_ORIGINAL_QUALITY_PRODUCTS.includes(asset.product);
  }

  return true;
};

export const isAudioType = (metadataStr) => {
  if (!metadataStr) {
    return false;
  }

  try {
    const metaData = JSON.parse(metadataStr);

    return _get(metaData, 'type', '').includes('audio/');
  } catch (e) {
    return false;
  }
};

export const isVideoType = (metadataStr) => {
  if (!metadataStr) {
    return false;
  }

  try {
    const metaData = JSON.parse(metadataStr);

    return _get(metaData, 'type', '').includes('video/');
  } catch (e) {
    return false;
  }
};